<ng-container *ngIf="vo$ | async ; let vo">
	<app-page >
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<app-button
				*ngIf="vo.userPermissions.has(ElementPermission.Edit) && vo.projectVersionCount > 1"
				id="{{ cmpId + 'version-switcher' }}"
				class="app-subscription-view__version-switcher-btn"
				[leftIcon]="DcIcons.SwitchVersion"
				(click)="openSwitchableConsumedProjectsModal()"
				i18n="@@subscription.versionSwitcher.action.btn">
				switcher-version
			</app-button>

			<app-button
				id="{{ cmpId + 'simulate' }}"
				class="app-subscription-view__simulate-btn"
				[leftIcon]="DcIcons.TestApi"
				(click)="navigateToSubscriptionSimulator()"
				i18n="@@subscription.simulator.simulate.btn">
				simulate
			</app-button>

			<button
				mat-icon-button
				class="app-subscription-view__action-btn"
				[matMenuTriggerFor]="actions"
				id="subscription-menu-btn">
				<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
			</button>

			<mat-menu #actions="matMenu">
				<ng-template matMenuContent>
					<button
						*ngIf="vo.userPermissions.has(ElementPermission.Delete)"
						id="{{ cmpId }}-delete-btn"
						(click)="openDeleteConfirmationPopup()"
						class="app-subscription-view__delete-btn"
						mat-menu-item>
						<mat-icon
							[svgIcon]="DcIcons.Delete"></mat-icon>
						<span
							i18n="@@general.action.delete">
							delete</span>
					</button>
					<button
						*ngIf="vo.userPermissions.has(ElementPermission.Permissions)"
						id="{{ cmpId }}-permission-btn"
						(click)="openPermissionsConfigModal()"
						class="app-subscription-view__delete-btn"
						mat-menu-item>
						<mat-icon
							[svgIcon]="DcIcons.LockClose"></mat-icon>
						<span
							i18n="@@general.permissions">
							permissions</span>
					</button>
					<button
						id="{{ cmpId }}-help-nav"
						mat-menu-item>
						<app-nav-doc
							[navigateToUrl]="FunctionalDocumentationKeys.SUBSCRIPTION">
							<span
								i18n="@@general.action.help">
								help</span>
						</app-nav-doc>
					</button>
				</ng-template>
			</mat-menu>
		</app-page-actions>

		<app-page-content>
			<div class="app-subscription-view">
				<mat-tab-group (selectedTabChange)="onTabChange()">
					<mat-tab>
						<ng-template
							mat-tab-label
							i18n="@@subscription.view.tab.general">
							general
						</ng-template>
						<ng-container
							[ngTemplateOutlet]="general"></ng-container>
					</mat-tab>
					<mat-tab>
						<ng-template
							mat-tab-label
							i18n="@@subscription.view.tab.subscriptions">
							subscriptions
						</ng-template>
						<ng-container
							[ngTemplateOutlet]="subscribers"></ng-container>
					</mat-tab>
					<mat-tab>
						<ng-template
							mat-tab-label
							i18n="@@subscription.view.tab.profiles.models">
							profiles & models
						</ng-template>
						<ng-container
							[ngTemplateOutlet]="profiles"></ng-container>
					</mat-tab>
					<!--<mat-tab>
						<ng-template
							mat-tab-label
							i18n="@@subscription.view.tab.rights">
							rights
						</ng-template>
						<ng-container
							[ngTemplateOutlet]="rights"></ng-container>
					</mat-tab>
					<mat-tab>
						<ng-template
							mat-tab-label
							i18n="@@subscription.view.tab.activities">
							activities
						</ng-template>
						<ng-container
							[ngTemplateOutlet]="activities"></ng-container>
					</mat-tab>-->
				</mat-tab-group>
			</div>
		</app-page-content>
	</app-page>

	<ng-template #general>
		<div class="app-subscription-view__general">
			<app-card-outline class="card-internal-metadata">
				<span
					card-outline-title
					i18n="@@subscription.view.internalMetadata">
					internal metadata
				</span>

				<div
					class="card-internal-metadata__subtitle"
					card-outline-subtitle>
				</div>

				<div
					class="card-internal-metadata__actions"
					card-outline-actions>
					<button
						*ngIf="vo.userPermissions.has(ElementPermission.Edit)"
						mat-icon-button
						class="internal-metadata__actions__edit-btn"
						(click)="updateInternalMetadata()">
						<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
					</button>
				</div>

				<div
					class="card-internal-metadata__content"
					card-outline-content>
					<app-internal-metadata-config
						[internalMetadata]="vo.internalMetadata"
						[isInViewMode]="true"></app-internal-metadata-config>
				</div>
			</app-card-outline>

			<app-card-outline class="card-public-metadata">
				<span
					card-outline-title
					i18n="@@subscription.view.publicMetadata">
					public metadata
				</span>

				<div
					class="card-public-metadata__subtitle"
					card-outline-subtitle>
				</div>

				<div
					class="card-public-metadata__actions"
					card-outline-actions>
					<button
						*ngIf="vo.userPermissions.has(ElementPermission.Edit)"
						mat-icon-button
						class="public-metadata__actions__edit-btn"
						(click)="updatePublicMetadata()">
						<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
					</button>
				</div>

				<div
					class="card-public-metadata__content"
					card-outline-content>
					<app-public-metadata-config
						[publicMetadata]="vo.publicMetadata"
						[isInViewMode]="true"></app-public-metadata-config>
				</div>
			</app-card-outline>

			<section class="subscription-columns">
				<app-panel
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					hasRefresh="true"
					[itemsCount]="vo.columns.size"
					[actions]="vo.userPermissions.has(ElementPermission.Edit) ? columnsActions : []"
					(search)="columnsGrid.search($event)"
					(refresh)="refreshColumnList()">
					<div
						class="app-panel__title"
						panel-title>
						<mat-icon [svgIcon]="ComponentIcons.Column"></mat-icon>
						<span
							i18n="@@subscription.view.column.list.title">
							columns</span>
					</div>

					<app-columns-config
						#columnsGrid="ColumnsGrid"
						[columns]="vo.columns"
						[isInViewMode]="true"
					></app-columns-config>
				</app-panel>
			</section>

			<app-card-outline class="card-datasets">
				<span
					card-outline-title
					i18n="@@subscription.view.datasets">
					datasets</span>

				<div card-outline-subtitle
						 class="card-datasets__subtitle">
					<app-status-badge
						*ngIf="vo.published && vo.published.status !== SubscriptionStatus.Waiting"
						[status]="vo.published.status"></app-status-badge>

					<app-status-badge
						*ngIf="vo.published && vo.published.status === SubscriptionStatus.Available"
						[status]="vo.published.isInSync? 'synced' : 'not-synced'"></app-status-badge>
				</div>

				<div card-outline-actions
						 class="card-datasets__actions" *ngIf="vo.published && vo.userPermissions.has(ElementPermission.Edit)">

					<app-button
						*ngIf="vo.published.status === SubscriptionStatus.Unpublish"
						[attr.data-disabled]="vo.actionInProgress === 'initialize' || vo.actionInProgress === 'in-progress'"
						id="{{ cmpId + 'initialize' }}"
						class="app-subscription-view__initialize-btn"
						[isInProgress]="vo.actionInProgress === 'initialize' || vo.actionInProgress === 'in-progress'"
						[isDisabled]="vo.actionInProgress === 'initialize' || vo.actionInProgress === 'in-progress'"
						[loaderSize]="15"
						[leftIcon]="DcIcons.Publish"
						(click)="openPublishConfirmPopup()"
						i18n="@@subscription.publication.action.initialize">
						initialize</app-button>

					<div *ngIf="vo.published.status !== SubscriptionStatus.Unpublish &&
						vo.published.status !== SubscriptionStatus.Waiting">
						<button
							mat-icon-button
							id="{{ cmpId }}-update-data-btn"
							matTooltip="update-data"
							i18n-matTooltip="@@subscription.publication.action.updateData"
							(click)="openUpdateDataConfirmPopup()">
							<mat-icon [svgIcon]="DcIcons.Input"></mat-icon>
						</button>
						<button
							*ngIf="vo.published.status === SubscriptionStatus.Available"
							mat-icon-button
							id="{{ cmpId }}-deactivate-btn"
							matTooltip="deactivate"
							i18n-matTooltip="@@subscription.publication.action.deactivate"
							(click)="openDeactivateConfirmPopup()">
							<mat-icon [svgIcon]="DcIcons.ShareOff"></mat-icon>
						</button>
						<button
							*ngIf="vo.published.status === SubscriptionStatus.UnAvailable"
							mat-icon-button
							matTooltip="activate"
							i18n-matTooltip="@@subscription.publication.action.activate"
							id="{{ cmpId }}-deactivate-btn"
							(click)="openActivateConfirmPopup()">
							<mat-icon [svgIcon]="DcIcons.Share"></mat-icon>
						</button>
						<button
							mat-icon-button
							id="{{ cmpId }}-clear-btn"
							matTooltip="clear-data"
							i18n-matTooltip="@@subscription.publication.action.clearData"
							(click)="openClearConfirmPopup()">
							<mat-icon [svgIcon]="DcIcons.Output"></mat-icon>
						</button>
					</div>
				</div>

				<div card-outline-content *ngIf="vo.published">
					<div class="card-datasets__content" >
						<div class="details" >
							<!-- Source -->
							<span
								class="caption"
								i18n="@@subscription.publication.source">
									source
								</span>
							<span class="value source-navigation">
									{{vo.published.datablockLabel}}
								<a appNavigate [navigateTo]="vo.published.datablockUrl">
									<mat-icon
										[svgIcon]="DcIcons.OpenInNewTab"
										matTooltip="open db in new tab"
										i18n-matTooltip="@@subscription.list.sourceTooltip"
										matTooltipPosition="after"></mat-icon>
									</a>
								</span>

							<!-- Result -->
							<span
								class="caption"
								i18n="@@subscription.publication.sourceDetails">
								source-details
							</span>

							<div class="value result">
								<app-overlay-badge
									[icon]="ComponentIcons.Column"
									[value]="vo.published.columnCount"
									[active]="false"></app-overlay-badge>
								<app-overlay-badge
									*ngIf="vo.published.dataCount !== 0"
									[icon]="ComponentIcons.Data"
									[value]="vo.published.dataCount"
									[active]="false"></app-overlay-badge>
							</div>

							<ng-container *ngIf="vo.published.history.length !== 0">
								<!-- Title -->
								<span
									class="caption"
									i18n="@@subscription.publicMetadata.form.title">
										title
									</span>
								<span class="value"
											[matTooltip]="vo.published.title"
											[matTooltipDisabled]="vo.published.title.length <= Configuration.maxLengthSubPublicMetadataTitleDisplay"
											matTooltipPosition="right">
										{{ vo.published.title | truncate: Configuration.maxLengthSubPublicMetadataTitleDisplay : 1 : 'end' }}
								</span>

								<!-- Details -->
								<!--<span
									class="caption"
									i18n="@@subscription.publicMetadata.form.description">
										details
									</span>
								<span class="value"
											[matTooltip]="vo.published.details"
											[matTooltipDisabled]="vo.published.details.length <= 50"
											matTooltipPosition="right">
										{{ vo.published.details  | truncate: 50 : 1 : 'end'}}
								</span>


								<span
									class="caption"
									i18n="@@subscription.publicMetadata.form.keywords">
										keywords
									</span>
								<span class="value">
										<app-tag-configurator
											[configuredTags]="vo.published.keywords"
											displayMode="keywords"
											configMode="View"></app-tag-configurator>
									</span>-->

								<!-- published by -->
								<span
									class="caption"
									i18n="@@subscription.publication.publishedBy">
										published-by
									</span>

								<div
									*ngIf="vo.published.publishedDate"
									class="value published-by">
									{{ vo.published.publishedDate | dayjsDate: 'DateTime' }}
									<app-avatar
										[avatar]="vo.published.publishedBy"
										[withTooltip]="true"></app-avatar>
								</div>
							</ng-container>
						</div>
						<div class="history" *ngIf="vo.published.history.length !== 0">
							<span
								i18n="@@subscription.publication.updates">
								updates
							</span>
							<div class="history__updates">
								<ng-container *ngFor="let update of vo.published.history">
									<app-status-badge
										[status]="update.status"></app-status-badge>

									<span
										[matTooltip]="update.action"
										[matTooltipPosition]="'after'">
										{{ update.action | truncate: 13: 1: 'end' }}
									</span>

									<app-overlay-badge
										class="small"
										[icon]="ComponentIcons.Column"
										[value]="update.columnCount"
										[active]="false"></app-overlay-badge>

									<app-overlay-badge
										class="small"
										[icon]="ComponentIcons.Data"
										[value]="update.lineCount"
										[active]="false"></app-overlay-badge>

									<span>
										<ng-container *ngIf="update.date">
										{{ update.date | dayjsDate: 'DateTime' }}</ng-container>
									</span>

									<span>
										<ng-container
											*ngIf="update.duration">
											{{update.duration | dayjsDurationFormat }}</ng-container>
										<ng-container
											*ngIf="!update.duration">
											0s</ng-container>
									</span>

									<app-avatar
										[avatar]="vo.published.publishedBy"
										[withTooltip]="true"></app-avatar>
								</ng-container>
							</div>
							<div class="history__btn">
								<button
									mat-stroked-button
									color="accent"
									(click)="openHistoryListModal()">
									<mat-icon [svgIcon]="DcIcons.Update"></mat-icon>
									<span
										i18n="@@subscription.publication.history.action">
										see-all
									</span>
								</button>
							</div>
						</div>
					</div>

					<div class="no-datasets__content"
							 *ngIf="vo.published.status === SubscriptionStatus.Unpublish  && vo.published.history.length === 0">
						<mat-icon
							[svgIcon]="DcIcons.Subscription"></mat-icon>
						<span
							i18n="@@subscription.status.notInitialized">
							subscription-unpublished</span>
					</div>
				</div>
			</app-card-outline>

		</div>
	</ng-template>

	<ng-template #profiles>
		<div class="app-subscription-view__profiles-models">
			<app-profiles
				class="profiles"
				[profiles]="vo.profiles"
				[columnModels]="vo.columnModels"
				[mode]="'STANDALONE'"
				(reloadProfiles)="refreshProfiles()"></app-profiles>

			<section class="models">
				<app-column-models
					class="models__column-models"
					[mode]="'STANDALONE'"
					[columnModels]="vo.columnModels"
					[availableColumns]="vo.columns"
					(reloadColumnModels)="refreshColumnModels()"></app-column-models>

				<app-filter-models class="models__filter-models"
					[mode]="'STANDALONE'"
				  [canRefresh]="true"
					[filterModels]="vo.filterModels"
					[hasSelection]="true"
					[availableColumns]="vo.columns"
					(reloadFilterModels)="refreshFilterModels()"></app-filter-models>
			</section>
		</div>
	</ng-template>

	<ng-template #subscribers>
		<div class="app-subscription-view__subscribers">
			<div class="query-filter-bar">
				<app-toggle-buttons
					id="filter-version"
					class="filter-version"
					[actions]="filterVersionOptions"></app-toggle-buttons>
			</div>

			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				[actions]="vo.userPermissions.has(ElementPermission.Edit) ? consumerActions: []"
				[actionsAvailable]="toggleActions"
				[itemsCount]="vo.consumedProjectList.elements.size"
				(search)="search($event)"
				(refresh)="refreshConsumedProjects()">
				<div
					class="app-panel__title"
					panel-title>
					<mat-icon [svgIcon]="DcIcons.Project"></mat-icon>
					<span
						i18n="@@subscription.consumedProject.list.title">
            projects</span>
				</div>
				<div panel-info>
					<ng-container *ngIf="selectionCount">
						<span>{{ selectionCount }} &#32;</span>
						<span
							i18n="@@general.selectedElements">
							selected-elements</span>
					</ng-container>
				</div>

				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{id: 'subscription-consumed-project-list',class: 'app-subscription-consumed-project-list'}"
					[dataSource]="vo.consumedProjectList.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="true"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					(onCellHoverChanged)="onCellHover($event)"
					(onSelectionChanged)="onSelectionChange($event)"
					(onContentReady)="onGridReady()">

					<dxo-selection
						[mode]="vo.userPermissions.has(ElementPermission.Edit)
							&& vo.currentFilterVersion !== FilterVersion.OtherVersions ? 'multiple' : 'none'"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="true"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<!-- Fixable in position columns	-->
					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container
						*ngFor="let col of vo.consumedProjectList.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'status'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'10%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="statusTemplate">
							<dxo-header-filter [dataSource]="consumeStatusHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'isInSync'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'15%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="isInSyncTemplate">
							<dxo-header-filter [dataSource]="syncHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'projectLabel'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'20%'"
							[visibleIndex]="col.visibleIndex"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'targetProjectVersions'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'15%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="targetProjectVersionsTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'profileLabel'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable ?? false"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'20%'"
							[visibleIndex]="col.visibleIndex"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'columnProfileCount'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable ?? false"
							[allowSorting]="true"
							[alignment]="'left'"
							[width]="'5%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="columnsTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'sourceProjectVersion'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable ?? false"
							[allowSorting]="true"
							[dataType]="col.type"
							[alignment]="'left'"
							[width]="'5%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="sourceProjectVersionTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'startDate'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[width]="'10%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="startDateTemplate"></dxi-column>
					</ng-container>


					<!--<dxi-column
							*ngIf="col.field === 'filters'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[width]="'10%'"
							[visibleIndex]="col.visibleIndex"
							cellTemplate="filtersTemplate"></dxi-column>-->

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visible]="vo.userPermissions.has(ElementPermission.Edit)"
						[visibleIndex]="vo.consumedProjectList.availableColumns.size + 1"
						[width]="90"
						[showInColumnChooser]="false"
						cellTemplate="actionsTemplate"></dxi-column>

					<div *dxTemplate="let cell of 'statusTemplate'">
						<app-status-badge
							[status]="cell.data['status']"></app-status-badge>
					</div>

					<div *dxTemplate="let cell of 'targetProjectVersionsTemplate'" class="target-versions">
							<div class="version-badge" *ngFor="let version of cell.data['targetProjectVersions']">
								<span>{{version}}</span>
							</div>
					</div>

					<div *dxTemplate="let cell of 'isInSyncTemplate'">
							<app-status-badge
								[status]="cell.data['isInSync'] ? 'synced' : 'not-synced'"></app-status-badge>
					</div>

					<div *dxTemplate="let cell of 'sourceProjectVersionTemplate'">
						<div class="version-badge">
							<span>{{cell.data['sourceProjectVersion']}}</span>
						</div>
					</div>

					<div class="columns-count" *dxTemplate="let cell of 'columnsTemplate'">
							<app-overlay-badge
								*ngIf="cell.data['columnProfileCount'] !== 0"
								[icon]="ComponentIcons.Column"
								[value]="cell.data['columnProfileCount']"
								[active]="true"
								[isOpen]="vo.openedOverlayConsumer.consumerId === cell.data['id']"
								(overlayDismiss)="closeColumnsPopover()"
								(click)="openColumnsPopover($event, cell.data['id'])">>
								<app-popover
									overlayContent
									label="columns"
									i18n-label="@@subscription.consumedProject.list.column.columns"
									[icon]="{ iconName: ComponentIcons.Column }"
									[count]="cell.data['columnProfileCount']"
									(adbPopoverClose)="closeColumnsPopover()">
									<div class="columns-details">
										<ng-container *ngFor="let column of cell.data['profileColumns']">
											<app-column-type
												[type]="column['type']"
												[isList]="column['isList']"></app-column-type>
											<span>{{ column.label }}</span>

											<mat-icon
												*ngIf="column['isHashed']; else emptyIcon"
												[svgIcon]="DcIcons.Encrypted">
											</mat-icon>

											<ng-template #emptyIcon>
												<span></span>
											</ng-template>
										</ng-container>
									</div>
									<!--<ng-container>
										<div
											*ngFor="let column of projectProfile.columns | toArray"
											class="column-row">
											<app-column-type
												[type]="column['type']"
												[isList]="column['isList']"></app-column-type>
											<span>{{ column.label }}</span>
											<mat-icon [svgIcon]="DcIcons.Encrypted"></mat-icon>
										</div>
									</ng-container>-->
								</app-popover>
							</app-overlay-badge>
					</div>

					<!--<div *dxTemplate="let cell of 'filtersTemplate'">
						<app-overlay-badge
							[icon]="cell.data['filters'].length !== 0 ? ComponentIcons.Filter : ComponentIcons.FilterOff"
							[value]="cell.data['filters'].length"
							[active]="true"
							[isOpen]="false">
							<app-popover
								overlayContent
								label="projects"
								i18n-label="@@subscription.view.consumedProject.list.column.filters"
								[icon]="{ iconName: ComponentIcons.Filter }"
								[count]="cell.data['filters'].length">
							</app-popover>
						</app-overlay-badge>
					</div>-->

					<div *dxTemplate="let cell of 'startDateTemplate'">
							<span>
									{{ cell.data['startDate'] | dayjsDate: 'DateTime' }}</span>
					</div>

					<div *dxTemplate="let cell of 'actionsTemplate'"
						[hidden]="cell.rowIndex !== currentlyHovered">
						<div class="actions-template" *ngIf="cell.data['isInCurrentVersion']">
							<button
								mat-icon-button
								class="actions-template__menu-btn"
								matTooltip="update"
								i18n-matTooltip="@@subscription.consumedProject.list.action.update"
								matTooltipPosition="left"
								(click)="updateConsumedProject(cell.data)">
								<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
							</button>

							<button
								mat-icon-button
								class="actions-template__menu-btn"
								matTooltip="update"
								i18n-matTooltip="@@subscription.consumedProject.list.action.delete"
								matTooltipPosition="left"
								(click)="deleteConsumedProject(cell.data)">
								<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
							</button>

							<button
								*ngIf="cell.data['status'] === ConsumeStatus.InProgress
								|| cell.data['status'] === ConsumeStatus.Paused"
								mat-icon-button
								id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
								class="actions-template__menu-btn"
								(click)="rowMenuOpen($event, cell.rowIndex)"
								[matMenuTriggerFor]="
									cell.data['status'] === ConsumeStatus.InProgress ? menuDeactivateConsumerActions
									: menuActivateConsumerActions"
								[matMenuTriggerData]="{ $implicit: cell.data }">
								<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
							</button>
						</div>

						<mat-menu #menuDeactivateConsumerActions="matMenu">
							<ng-template matMenuContent let-data>
								<button *ngFor="let a of deactivateConsumeActions"
												id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
												(click)="a.action(data)"
												mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>

						<mat-menu #menuActivateConsumerActions="matMenu">
							<ng-template matMenuContent let-data>
								<button *ngFor="let a of activateConsumeActions"
												id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
												(click)="a.action(data)"
												mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>
					</div>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="10"></dxo-paging>

					<dxo-pager [visible]="true"></dxo-pager>

					<!-- Filterable columns	-->
					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-filter-row [visible]="true"></dxo-filter-row>

				</dx-data-grid>
			</app-panel>
		</div>
	</ng-template>

	<ng-template #rights>
		rights content
	</ng-template>

	<ng-template #activities>
		activities content
	</ng-template>


</ng-container>
